import React, { createContext, useState, useEffect, useContext } from 'react';
import { useInvoicePermissions } from '../hooks/purchaseInvoices/useInvoicePermissions';
import { useNavigate, useLocation } from 'react-router-dom';

const PermissionsContext = createContext(null);

export const PermissionsProvider = ({ children }) => {
  const permissions = useInvoicePermissions();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const handleRoleUpdated = (event) => {
      const { previousRole, newRole } = event.detail;
      if (previousRole !== newRole) {
        navigate(location.pathname + '?refresh=' + Date.now(), { replace: true });
      }
    };
    
    window.addEventListener('role-updated', handleRoleUpdated);
    return () => {
      window.removeEventListener('role-updated', handleRoleUpdated);
    };
  }, [navigate, location]);
  
  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);